import { TowerModel } from '../../../model/tower.model';
import { SpanModel } from '../../../model/span.model';
import { LineModel } from '../../../model/line.model';
import { ColDef, ValueGetterParams } from '@ag-grid-community/core';
import { prepareAdditionalDataColumns } from '../config/data.config';

const getUniqueAttributeNames = (data: TowerModel[] | SpanModel[] | LineModel[]) => [...new Set(data.flatMap(d => Object.keys(d.attributes)))]

export const setColumnsDef = (data: TowerModel[] | SpanModel[] | LineModel[]): ColDef[] => [
  ...getUniqueAttributeNames(data).map(name => ({
    headerName: name,
    field: name,
    valueGetter: (params: ValueGetterParams) => {
      const attr = params.data.attributes[name];
      return attr || '';
    }
  })),
  ...prepareAdditionalDataColumns()
];



